
import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'

const SignUp = () => import('../../../coreui/components/SignUp')
const Login = () => import('../../../coreui/components/Login')
const Welcome = () => import('../../../coreui/components/Welcome')
const NoDeepLink = () => import('../../../coreui/components/NoDeepLink')
const EmailVerify = () => import('../../../coreui/components/EmailVerify')
const DisplayHTML = () => import('../../../coreui/components/DisplayHTML')
const PasswordReset = () => import('../../../coreui/components/PasswordReset')
const PageNotFound = () => import('../../../coreui/components/PageNotFound')
const SupportTicket = () => import('../../../coreui/components/SupportTicket')
const ServerTable = () => import('@/../../coreui/components/ServerTable')
import LoginMixin from '@/mixins/loginUtils'
import loginStore from '@/../../coreui/store/login.js'
const Loggedout = () => import('../../../coreui/components/LoggedOut')
Vue.use(Router)
var defaultRoute = [{
  path: '/',
  redirect: '/Welcome'
}]
var NoDeepLinkRoute = [{
  path: '/NoDeepLink',
  name: 'NoDeepLink',
  component: NoDeepLink
}]
var EmailVerifyRoute = [{
  path: '/EmailVerify/',
  name: 'EmailVerify',
  component: EmailVerify,
	props: true
}]
var WelcomeRoute = [{
  path: '/Welcome',
  name: 'Welcome',
  component: Welcome
}]
var LoggedoutRoute = [{
  path: '/Loggedout',
  name: 'Loggedout',
  component: Loggedout
}]
var SignUpRoute = [{
  path: '/SignUp',
  beforeEnter() {
    location.href = "https://entrinsia.com/sign-up"
  }
}]
var LoginRoute = [{
  path: '/',
  name: 'Login',
  component: Login
}]
var PWResetRoute = [{
  path: '/PasswordReset/',
  name: 'PasswordReset',
  component: PasswordReset
}]
var ServerTableRoute = [{
  path: '/Table',
  name: 'Table',
  component: ServerTable
}]
var SupportTicketRoute = [{
  path: '/SupportTicket',
  name: 'SupportTicket',
  component: SupportTicket
}]
var DisplayHTMLRoute = [{
  path: '/DisplayHTML',
  name: 'DisplayHTML',
  component: DisplayHTML,
  props: true
}]
var routes = defaultRoute
  .concat(LoginRoute)
	.concat(NoDeepLinkRoute)
  .concat(PWResetRoute)
  .concat(WelcomeRoute)
  .concat(LoggedoutRoute)
  .concat(ServerTableRoute)
  .concat(SupportTicketRoute)
  .concat(SignUpRoute)
  .concat(DisplayHTMLRoute)
	.concat(EmailVerifyRoute)

const VueRouter = new Router ({
  mode: 'history',
  routes,
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-exact-active',
})

// routes.forEach((i) => {
//   VueRouter.addRoute(i)
// })
VueRouter.beforeResolve(async function(to, from, next)  {
  console.log('fromTo: ', from, to)
	if (to.query['type'] == 'deepLink') {
		console.log('deeplink received')
		if (to.query['scope'] != null && to.query['scope'] != 'all' && to.query['scope'] != 'web' ) {
			// this should only be opened by app
			try {
				next({path: '/NoDeepLink'}) 
				return
			} catch(e) {
				console.log(e)
			}
		} else try {
			let params = to.query['jsonData']
			console.log('params: ' + params)
			let decoded = JSON.parse(params)
			console.log('decoded: ', decoded)
			next({path: to.path, query: decoded}) 
			return
		} catch(e) {
			console.log(e)
		}
	}

	console.log(to.path)
	console.log(to.query)
  if (!loginStore.state.initialLoginComplete) {
    //remove any localStorage holdovers
    localStorage.removeItem('origToken')
    localStorage.removeItem('token')
  }
  // let authenticated = true
  let authenticated = await LoginMixin.methods.checkLoginStatus(from, to)
  console.log('authenticated status is: ', authenticated)
  if (to.path == '/Welcome' || to.path == '/' || to.path =='/PasswordReset/' || to.path == '/Loggedout' || to.path == '/EmailVerify/' ) {
		console.log('fromto: going to next: ', to.path)
    next()
  } else if (to.path == '/NoDeepLink') {
		console.log('going to deep link path')
		next()
	}else if (authenticated) {
    loginStore.state.initialLoginComplete = true
    console.log('fromto: going to next: ', to.path)
    next(); // allow to enter route
  } else {
    // localStorage.setItem('continue', to.path)
    loginStore.state.loggedIn = false
    try {
      next({name: 'Welcome'}) // go to '/login';
    } catch(e) {
      console.log(e)
    }
  }
})

export default VueRouter
